import { FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst } from "core/modules/layout.module";
import { Description, DescriptionWrapper } from "shared/pages/explore/styles";
import { AppTester } from "supporting";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ShowMoreContent } from "shared/pages/designer/styles";
import { isTeamChannel } from "shared/pages/teams/const/ModerationTypes";

const formatTextWithLineBreaks = (text: string | string[] | undefined): string => {
    if (typeof text !== 'string' || !text) return '';
    
    return text.replace(/\n/g, '<br>');
};

interface TeamDescriptionProps {
    team: any;
    description: string | string[] | undefined;
}

interface TeamDescriptionProps {
    team: any;
    description: string | string[] | undefined;
}

const TeamDescription = ({ team, description }: TeamDescriptionProps) => {
    const {
        contextName: context,
        moderationType,
        isShowTeachersCheckbox: isShowTeachersCheckboxProp,
        isShowFullDescription,
    } = team;

    const hasTeamEmblem = useMemo(
        () => ((!!team?.titleImages?.length && !!team?.isShowTeamEmblem))
        , [team]);

    const superPuperGames = useMemo(
        () => ((team?.contextName  === 'superpupergames-mediiia'))
        , [team]);

    const { t } = useTranslation();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const is1024 = useBreakpoint(LayoutConst.screen.m_1024);
    const is430 = useBreakpoint(470);
    const isMobile = useIsMobile();
    const isAgeytomesh = useMemo(() => (context === 'ageytomesh'), [context])

    const { isChannel } = isTeamChannel(moderationType);
    const isShowTeachersCheckbox = isChannel || isShowTeachersCheckboxProp

    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        setExpanded((prev) => !prev);
    };

    const formattedDescription = useMemo(() => {
        return formatTextWithLineBreaks(description);
    }, [description]);

    const descriptionLines = useMemo(() => {
        if (is743 && !superPuperGames) {
            return 9;
        }

        if (isShowFullDescription || (superPuperGames && is1024)) {
            return 100;
        }

        if (!hasTeamEmblem) {
            return 4;
        }
        if (isShowTeachersCheckbox || !team?.buttons?.length) {
            return 8;
        }
        if (isMobile) {
            return 10;
        }
        return 6;
    }, [team, is743, hasTeamEmblem, isShowTeachersCheckbox, isShowFullDescription, isMobile, superPuperGames])

    const ShowMore = (props: any) => (
        <ShowMoreContent {...props}>{props.children}</ShowMoreContent>
    )

    if (!description?.length) {
        return null;
    }

    return (
        <FlexBox widthMobile={is743 ? "calc(100vw - 20px)" : "100%"} direction="column" directionMobile="column">
            <DescriptionWrapper disableOffset={is430 && !isAgeytomesh}
                direction="column" directionMobile="column"
                hideMore={isShowFullDescription}
            >
                {isShowFullDescription && (
                    <Description preLine>
                        <div dangerouslySetInnerHTML={{ __html: formattedDescription }} />
                    </Description>
                )}

                <ShowMore
                    more={t('show_more_text')}
                    less={t('show_less_text')}
                    importantStyles
                    lines={descriptionLines}
                    breakSpace
                    isOnlines={AppTester.isOnlines()}
                    expanded={expanded}
                    onClick={handleToggle}
                >

                    <div dangerouslySetInnerHTML={{ __html: formattedDescription }} />
                </ShowMore>
            </DescriptionWrapper>
        </FlexBox>
    )
}

export default TeamDescription;import { FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst } from "core/modules/layout.module";
import { Description, DescriptionWrapper } from "shared/pages/explore/styles";
import { AppTester } from "supporting";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ShowMoreContent } from "shared/pages/designer/styles";
import { isTeamChannel } from "shared/pages/teams/const/ModerationTypes";

const formatTextWithLineBreaks = (text: string | string[] | undefined): string => {
    if (typeof text !== 'string' || !text) return '';
    
    return text.replace(/\n/g, '<br>');
};

interface TeamDescriptionProps {
    team: any;
    description: string | string[] | undefined;
}

interface TeamDescriptionProps {
    team: any;
    description: string | string[] | undefined;
}

const TeamDescription = ({ team, description }: TeamDescriptionProps) => {
    const {
        contextName: context,
        moderationType,
        isShowTeachersCheckbox: isShowTeachersCheckboxProp,
        isShowFullDescription,
    } = team;

    const hasTeamEmblem = useMemo(
        () => ((!!team?.titleImages?.length && !!team?.isShowTeamEmblem))
        , [team]);

    const superPuperGames = useMemo(
        () => ((team?.contextName  === 'superpupergames-mediiia'))
        , [team]);

    const { t } = useTranslation();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const is1024 = useBreakpoint(LayoutConst.screen.m_1024);
    const is430 = useBreakpoint(470);
    const isMobile = useIsMobile();
    const isAgeytomesh = useMemo(() => (context === 'ageytomesh'), [context])

    const { isChannel } = isTeamChannel(moderationType);
    const isShowTeachersCheckbox = isChannel || isShowTeachersCheckboxProp

    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        setExpanded((prev) => !prev);
    };

    const formattedDescription = useMemo(() => {
        return formatTextWithLineBreaks(description);
    }, [description]);

    const descriptionLines = useMemo(() => {
        if (is743 && !superPuperGames) {
            return 9;
        }

        if (isShowFullDescription || (superPuperGames && is1024)) {
            return 100;
        }

        if (!hasTeamEmblem) {
            return 4;
        }
        if (isShowTeachersCheckbox || !team?.buttons?.length) {
            return 8;
        }
        if (isMobile) {
            return 10;
        }
        return 6;
    }, [team, is743, hasTeamEmblem, isShowTeachersCheckbox, isShowFullDescription, isMobile, superPuperGames])

    const ShowMore = (props: any) => (
        <ShowMoreContent {...props}>{props.children}</ShowMoreContent>
    )

    if (!description?.length) {
        return null;
    }

    return (
        <FlexBox widthMobile={is743 ? "calc(100vw - 20px)" : "100%"} direction="column" directionMobile="column">
            <DescriptionWrapper disableOffset={is430 && !isAgeytomesh}
                direction="column" directionMobile="column"
                hideMore={isShowFullDescription}
            >
                {isShowFullDescription && (
                    <Description preLine>
                        <div dangerouslySetInnerHTML={{ __html: formattedDescription }} />
                    </Description>
                )}

                <ShowMore
                    more={t('show_more_text')}
                    less={t('show_less_text')}
                    importantStyles
                    lines={descriptionLines}
                    breakSpace
                    isOnlines={AppTester.isOnlines()}
                    expanded={expanded}
                    onClick={handleToggle}
                >

                    <div dangerouslySetInnerHTML={{ __html: formattedDescription }} />
                </ShowMore>
            </DescriptionWrapper>
        </FlexBox>
    )
}

export default TeamDescription;